import { Info } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Alert, AlertDescription, AlertTitle } from '~/components/ui/alert';

import type { RevenueSource } from '../../types/experiment.types';

interface Props {
  source: RevenueSource | null | undefined;
}

/**
 * Once-per-page note that this experiment's revenue comes from a fallback
 * source (GA4 / Adobe had no revenue, so Google Ads is used). The source is
 * decided once per experiment, so one banner covers every revenue figure below.
 */
export function RevenueSourceBanner({ source }: Props) {
  const { t } = useTranslation('experiments');
  if (!source?.is_fallback) return null;
  return (
    <Alert className="border-primary/20 bg-primary/5 text-foreground [&>svg]:text-primary">
      <Info className="h-4 w-4" aria-hidden />
      <AlertTitle>
        {t('detail.revenueSource.fallbackTitle', { source: source.source_label })}
      </AlertTitle>
      <AlertDescription className="text-muted-foreground">{source.description}</AlertDescription>
    </Alert>
  );
}
